import { Box, Menu, MenuItem, Typography, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  BGcolor01,
  BGColor02,
  blueColor04,
  colorRed,
  greyColor40,
  greyColor41,
  lightBlueColor03,
  logoImgborder1,
  whiteColor,
} from "../../configs/styles/muiThemes";
import { DASHBOARD_NAVBAR, DISABLE_ALL_MENU } from "../../utils/data";
import DashboardMenu from "../../pages/Dashboard/DashboardMenu";
import DashboardHeader from "../../pages/Dashboard/DashboardHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

const DashboardLayout = ({
  children,
  activeMenu,
  activeSubMenu,
  disableAll,
  disableAllEmpty,
  isLoading,
  hideBusinessData,
  handleOpenVideoGuide,
  handleAddBusiness,
  isAddBusinessDisabled,
  hideMobileMenu,
  hideNavBar,
}) => {
  const location = useLocation();
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const [inventoryCountInfo, setInventoryCountInfo] = useState(null);
  const [orderCountInfo, setOrderCountInfo] = useState(null);

  const [userFrom, setUserFrom] = useState("");

  const { activeBusinessInfo } = useSelector((state) => state.businessPreview);
  const { dashboardData, statsCountInfo, dashboardDataLoader } = useSelector(
    (state) => state.businessDashboard
  );

  const navigate = useNavigate();

  const onMenuClick = (route) => {
    navigate(`/${sessionStorage.getItem("costboWEBURL")}${route}`);
  };

  const getUserFromValue = () => {
    const queryParams = new URLSearchParams(location.search);
    const userFromValue = queryParams.get("userFrom");
    const sessionUserFrom = sessionStorage.getItem("userFrom");

    console.log("LOCATION____UERFROM___:", { userFromValue, sessionUserFrom });

    if (userFromValue === "app") {
      setUserFrom(userFromValue);
      sessionStorage.setItem("userFrom", userFromValue);
    } else if (sessionUserFrom === "app") {
      setUserFrom(sessionUserFrom);
    } else {
      setUserFrom("");
      sessionStorage.setItem("userFrom", "");
    }
  };

  useEffect(() => {
    if (statsCountInfo) {
      const orderSummary = statsCountInfo?.orderCountInfo?.details;
      const orderCountData = orderSummary?.statusCounts?.reduce(
        (preValue, currentValue) => {
          return {
            ...preValue,
            [currentValue?.id]: currentValue?.count,
          };
        },
        {}
      );

      setOrderCountInfo(orderCountData);
      setInventoryCountInfo(statsCountInfo?.inventoryCountInfo);
    }

    return () => {};
  }, [statsCountInfo]);

  useEffect(() => {
    getUserFromValue();

    return () => {};
  }, [location]);

  return (
    <Box position="relative">
      <Box sx={styles.stickyTop}>
        <DashboardHeader
          activeMenu={activeMenu}
          activeSubMenu={activeSubMenu}
          disableMenu={
            isLoading
              ? DISABLE_ALL_MENU
              : disableAll
              ? DISABLE_ALL_MENU?.filter((item) => item != "store")
              : []
          }
          handleOpenVideoGuide={handleOpenVideoGuide}
          handleAddBusiness={handleAddBusiness}
          isAddBusinessDisabled={isAddBusinessDisabled}
          isUserFromApp={userFrom === "app"}
          hideBusinessData={hideBusinessData}
          hideMobileMenu={hideMobileMenu}
        />
      </Box>

      <Box display={{ md: "flex", xs: "block" }} alignItems="flex-start">
        <Box sx={styles.menuStickyLeft}>
          <DashboardMenu
            activeMenu={activeMenu}
            activeSubMenu={activeSubMenu}
            disableMenu={
              isLoading
                ? DISABLE_ALL_MENU
                : disableAll
                ? DISABLE_ALL_MENU?.filter((item) => item != "store")
                : []
            }
            hideBusinessData={hideBusinessData}
          />
        </Box>
        <Box
          sx={{
            flex: 1,
            mt: {
              md: "45px",
              xs:
                activeMenu != "store" && activeMenu != "howToVideoGuides"
                  ? "90px"
                  : "45px",
            },
          }}
        >
          {!hideNavBar && matches && (
            <Box
              sx={{
                pt: 0.8,
                background: whiteColor,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                gap: "50px",
                height: "37px",
                position: "sticky",
                top: 45,
                zIndex: 201,
                boxShadow: "0 1px 8px rgb(35 44 62 / 4%)",
              }}
            >
              {DASHBOARD_NAVBAR?.map((item, index) =>
                item?.subMenu?.length > 0 ? (
                  <NavSubMenuItem
                    label={item?.label}
                    icon={item?.icon}
                    subMenu={item?.subMenu}
                    isActive={
                      // item?.label === "Controls"
                      //   ? activeMenu
                      // :
                      activeMenu === item?.value
                    }
                    onClick={(data) => onMenuClick(data)}
                    // open={open}
                    // anchorEl={anchorEl}
                    // handleClose={handleClose}
                    // handleClick={handleClick}
                    key={`menu_${index}`}
                    isSingleBusiness={
                      !activeBusinessInfo?.mainBranch &&
                      !activeBusinessInfo?.mainBranchId
                    }
                    isMainBusiness={activeBusinessInfo?.mainBranch}
                    isNew={item.new}
                  />
                ) : (
                  <NavItem
                    label={item?.label}
                    icon={item?.icon}
                    isActive={activeMenu === item?.value}
                    onClick={() =>
                      navigate(
                        `/${sessionStorage.getItem("costboWEBURL")}${
                          item?.route
                        }`
                      )
                    }
                    orderCountInfo={orderCountInfo}
                    inventoryCountInfo={inventoryCountInfo}
                    isNew={item.new}
                  />
                )
              )}
            </Box>
          )}
          <Box sx={{ ...styles.content }}>{children}</Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;

const NavItem = ({ icon, label, onClick, isActive, orderCountInfo, isNew }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      pb="5px"
      sx={{
        cursor: "pointer",
        color: isActive ? blueColor04 : greyColor40,
        borderBottom: isActive
          ? "3px solid" + blueColor04
          : "3px solid" + whiteColor,
        "&:hover": {
          borderBottom: "3px solid" + blueColor04,
          color: blueColor04,
        },
      }}
      onClick={onClick}
    >
      <Box component="img" src={icon} width="17px" height="auto" />

      <Typography
        component="h3"
        fontSize={{ xs: 12.5, md: 12.5 }}
        fontWeight={500}
        // textAlign="center"
        ml="6px"
        position="relative"
      >
        {label}

        {label === "Orders" && orderCountInfo?.ordercreated > 0 && (
          <Box sx={styles.badgeDot}>{orderCountInfo?.ordercreated}</Box>
        )}

        {/* {isNew && (
          <Typography
            sx={{
              ml: 1.5,
              background: "linear-gradient(to right, #ff2e71 0%, #ff0052 100%)",
              color: whiteColor,
              fontSize: 8,
              fontWeight: 700,
              borderRadius: "4px",
              p: "4px 4px",
              lineHeight: 1,
            }}
          >
            New
          </Typography>
        )} */}
      </Typography>
    </Box>
  );
};

const NavSubMenuItem = ({
  icon,
  label,
  isActive,
  onClick,
  subMenu,
  isSingleBusiness,
  isMainBusiness,
  isNew,
  disabled,
  orderCountInfo,
}) => {
  const [hoveredSubMenuIndex, setHoveredSubMenuIndex] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    console.log("mouse hitt", event.currentTarget);

    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        pb="5px"
        sx={{
          cursor: "pointer",
          color: isActive ? blueColor04 : greyColor40,
          borderBottom: isActive
            ? "3px solid" + blueColor04
            : "3px solid" + whiteColor,
          "&:hover": {
            borderBottom: "3px solid" + blueColor04,
            color: blueColor04,
          },
        }}
        onMouseEnter={handleClick}
      >
        <Box component="img" src={icon} width="17px" height="auto" />
        <Typography
          component="h3"
          fontSize={{ xs: 12.5, md: 12.5 }}
          fontWeight={500}
          ml="6px"
          position="relative"
        >
          {label}
        </Typography>
        {isNew && (
          <Typography
            sx={{
              ml: 1.5,
              background: "linear-gradient(to right, #ff2e71 0%, #ff0052 100%)",
              color: whiteColor,
              fontSize: 8,
              fontWeight: 700,
              borderRadius: "4px",
              p: "4px 4px",
              lineHeight: 1,
            }}
          >
            New
          </Typography>
        )}
      </Box>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{ p: 0 }}
        PaperProps={{
          sx: {
            overflow: "visible",
          },
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          sx: { py: 0 },
        }}
      >
        {subMenu?.map((item, index) => {
          const hasThirdMenu = item.subMenu?.length > 0;
          if (
            (item?.mainOlny && !isMainBusiness) ||
            (item?.onlyMultiBranch && isSingleBusiness)
          )
            return null;

          return (
            <>
              <MenuItem
                sx={{
                  px: 1,
                  py: 0.35,
                  // minHeight: "20px",
                  minWidth: "140px",
                  backgroundColor: whiteColor,
                  color: greyColor40,
                  fontSize: { xs: 11.5, md: 11.5 },
                  fontWeight: 500,
                  borderBottom: "3px solid" + whiteColor,
                  // borderBottom:
                  //   subMenu?.length - 1 === index
                  //     ? "none"
                  //     : "0.5px solid" + BGcolor01,
                  "&:hover": {
                    backgroundColor: whiteColor,
                    color: blueColor04,
                    borderBottom: "3px solid" + blueColor04,
                  },
                  "&:focus": { backgroundColor: whiteColor },
                }}
                onClick={() => onClick(item?.route)}
                key={index}
                onMouseEnter={() =>
                  hasThirdMenu && setHoveredSubMenuIndex(index)
                }
                onMouseLeave={() =>
                  hasThirdMenu && setHoveredSubMenuIndex(null)
                }
                position="relative"
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ width: "100%" }}
                  gap={1}
                >
                  {item?.label}
                  {hasThirdMenu && (
                    <KeyboardDoubleArrowRightIcon sx={{ fontSize: 17 }} />
                  )}
                </Box>

                {hasThirdMenu && hoveredSubMenuIndex === index && (
                  <Box
                    sx={{
                      position: "absolute",
                      left: "100%",
                      top: 0,
                      backgroundColor: "white",
                      minWidth: "100px",
                      zIndex: 1000,
                      borderRadius: "6px",
                      border: logoImgborder1,
                    }}
                  >
                    {item?.subMenu.map((thirdItem, thirdIndex) => {
                      if (thirdItem?.mainOlny && !isMainBusiness) return null;
                      return (
                        <Box
                          key={`third-${thirdIndex}`}
                          sx={{
                            padding: "2px 8px",
                            cursor: "pointer",
                            "&:hover": {
                              background: lightBlueColor03,
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            onClick(thirdItem?.route);
                            // onSubMenuClick(thirdItem.route);
                          }}
                        >
                          <Typography
                            component="h3"
                            fontSize="11px"
                            color={greyColor40}
                            fontWeight={500}
                            lineHeight="26px"
                          >
                            {thirdItem.label}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </MenuItem>
            </>
          );
        })}
      </Menu>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    backgroundColor: BGColor02,
  },

  content: {
    p: { xs: "0px", md: "0px 25px 25px 25px" },
    mx: { xs: "15px", md: "0px" },
  },

  stickyTop: {
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 201,
    pb: 1.5,
  },

  menuStickyLeft: {
    display: { md: "block", xs: "none" },
    position: { md: "sticky", xs: "static" },
    top: 0,
    left: 0,
    height: "calc(100vh - 45px)",
    // zIndex: 100,
    backgroundColor: BGColor02,
  },
  menuItem: (isActive) => ({
    p: "19px 10px",
    borderBottom: isActive ? `3px solid ${blueColor04}` : "none",
    cursor: "pointer",
    color: isActive ? blueColor04 : greyColor40,
    "&:hover": {
      borderBottom: `3px solid ${blueColor04}`,
      color: blueColor04,
    },
  }),

  badgeDot: {
    width: "16px",
    height: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "10px",
    fontSize: "9px",
    fontWeight: 500,
    color: whiteColor,
    backgroundColor: colorRed,
    position: "absolute",
    top: -3,
    right: -15,
  },
};
